// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__32_6A","author":"Table_author__C5GAb","authorImage":"Table_authorImage__2a5p8","unreadRow":"Table_unreadRow__11y_s"};